import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("kyvixe_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401 && typeof window !== "undefined") {
      const isAdminRoute = window.location.pathname.startsWith("/admin");
      if (isAdminRoute && !window.location.pathname.endsWith("/login")) {
        localStorage.removeItem("kyvixe_token");
        window.location.href = "/admin/login";
      }
    }
    return Promise.reject(err);
  },
);

export const KYVIXE = {
  logo: "https://customer-assets-lxgj4vgw.emergentagent.net/job_71b7e8ca-a99e-4074-9310-f4abf4b0e51c/artifacts/x1webu2k_ChatGPT%20Image%20Jul%2017%2C%202026%2C%2012_52_44%20PM.png",
  email: "kyvixe@gmail.com",
  instagram: "https://www.instagram.com/kyvixe",
  facebook: "https://www.facebook.com/profile.php?id=61591786085242",
};
